export class EntraUser {
    id: string = '';
    displayName: string = '';
    department: string = '';
    mail: string = '';
    userPrincipalName: string = '';
    jobTitle: string = '';
    managerId: string = '';
    companyName: string = '';
}